<template>
  <Collapse simple class="collapse-warpper" value="1">
    <Panel name="1" class="collapse-panel">
      <span class="panel-title">{{initdata.title}}</span>
      <div slot="content">
        <!-- 复选框组 on-change 类似于watch-->
        <CheckboxGroup v-model="dataList" @on-change="groupChange">
          <drop
            class="sort-item hello"
            v-for="(item,index) in initdata.dataList"
            :data-index="index"
            :key="item.label"
            @eldrop="eldrop"
            :el-index="index"
          >
            <!-- 复选框 -->
            <Checkbox :label="index">
              <img :src="item.iconPath" class="sort-label-icon">
              <span class="sort-label">{{item.label}}</span>
            </Checkbox>
            <!-- 删除按钮 -->
            <Icon v-if="initdata.edit" class="sort-del" size="16" type="md-close" @click.stop="delSort(index)"/>
            <!-- 复选框人数 -->
            <span class="sort-number">{{item.number}}</span>
          </drop>
        </CheckboxGroup>
        <div class="add-sort" v-if="initdata.edit">
          <Icon type="ios-add" size="14" v-show="!editMode"/>
          <div class="add-text" v-show="!editMode" @click="edit">添加分类</div>
          <Input
            size="small"
            v-show="editMode"
            v-model="addValue"
            search
            enter-button="添加"
            placeholder="请输入分类"
            @on-search="addSort"
          />
        </div>
      </div>
    </Panel>
  </Collapse>
</template>

<script>
import drop from "../dragger/drop";
export default {
  created() {
    this.groupChange = this._.debounce(this._groupChange, 800, false);
  },
  mounted() {
    console.log(this.initdata);
  },
  props: ["initdata", "filterListIndex"],
  data() {
    return {
      dataList: [],
      editMode: false,
      addValue: ""
    };
  },
  methods: {
    /* 添加分类编辑模式 */
    edit() {
      this.editMode = true;
    },
    /* 复选组勾选装填改变 */
    _groupChange() {
      console.log(123123123);

      this.$emit("event", {
        fn: "groupChange",
        params: {
          selectedIndex: this.dataList,
          filterListIndex: this.filterListIndex
        }
      });
    },
    groupChange() {}, // 只是个空壳
    delSort(index) {
      this.$emit("event", {
        fn: "delSort",
        params: {
          delIndex: index,
          filterListIndex: this.filterListIndex
        }
      });
    },
    addSort() {
      /* 退出编辑模式 */
      this.editMode = false;
      this.$emit("event", {
        fn: "addSort",
        params: {
          addValue: this.addValue,
          filterListIndex: this.filterListIndex
        }
      });
      /* 初始化分类名称 */
      this.addValue = "";
    },
    eldrop(e) {
      this.$emit("event", {
        fn: "sortDrop",
        params: {
          filterListIndex: this.filterListIndex,
          ...e
        }
      });
    }
  },
  components: {
    drop
  }
};
</script>
<style scoped lang="less">
@import "./collapse.less";
.add-sort {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #a3a3a3;
  margin-top: 10px;
}
.add-text {
  margin-left: 10px;
  color: #4b4b4b;
  cursor: pointer;
  &:hover {
    color: #d22b2b;
  }
}
.sort-label-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-left: 10px;
}
</style>

